import React from "react";
import { Modal, ModalBody, Button } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { getAuth } from "firebase/auth"; // Import Firebase Auth

const DiscountModal = ({ isOpen, toggle }) => {
  const navigate = useNavigate();

  const handleTakeQuiz = () => {
    const auth = getAuth();
    const user = auth.currentUser;
    console.log("User:", user); // Log the user object for debugging
    if (user) {
      // User is authenticated, navigate to the quiz page
      navigate("/speaking-assessment");
    } else {
      // User is not authenticated, navigate to the sign-in page
      navigate("/login-page");
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <div
        style={{
          position: "relative",
          background: "linear-gradient(to right, #e0eafc, #cfdef3)",
          borderRadius: "10px",
          padding: "2rem 1.5rem",
          fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        }}
      >
        {/* Custom Close Button */}
        <button
          type="button"
          onClick={toggle}
          aria-label="Close"
          style={{
            position: "absolute",
            top: "10px",
            right: "15px",
            border: "none",
            background: "transparent",
            fontSize: "1.8rem",
            fontWeight: "bold",
            color: "#333",
            cursor: "pointer",
          }}
        >
          &times;
        </button>

        {/* Modal Heading */}
        <h4
          className="text-center mb-3"
          style={{
            fontWeight: "700",
            fontSize: "1.5rem",
            color: "#000080",
          }}
        >
          🎤 Ready to Shine on Stage? 🎤
        </h4>

        {/* Modal Body */}
        <ModalBody className="text-center">
          <p style={{ fontSize: "1.1rem", color: "#333" }}>
            Test your public speaking skills today and get a{" "}
            <strong style={{ fontWeight: "bold", color: "#000" }}>
              10% discount
            </strong>{" "}
            on our engaging and impactful speaking courses!
          </p>

          {/* Buttons */}
          <div className="d-flex justify-content-center gap-3 mt-4 flex-wrap">
            <Button
              style={{
                backgroundColor: "#000080",
                borderColor: "#000080",
                padding: "0.6rem 1.2rem",
                fontWeight: "600",
                transition: "all 0.3s ease",
                width: "9.5rem",
                height: "2.5rem",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#1a1aff";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#000080";
              }}
              onClick={handleTakeQuiz} // Call the function to handle navigation
            >
              🚀 Take Quiz
            </Button>

            <Button
              color="secondary"
              style={{
                padding: "0.6rem 1.2rem",
                fontWeight: "600",
                backgroundColor: "#6c757d",
                borderColor: "#6c757d",
                transition: "all 0.3s ease",
                width: "9.5rem",
                height: "2.5rem"
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#5a6268";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#6c757d";
              }}
              onClick={() => {
                toggle();
                navigate("/home");
              }}
            >
              🙅‍♂️ Not Interested
            </Button>
          </div>
        </ModalBody>
      </div>
    </Modal>
  );
};

export default DiscountModal;